import { Component, OnInit } from '@angular/core';
import { ApiService } from '../core/api.service';
import { BlendEvent, UserInfoSetApiOutput } from '../shared/models';
import { BlendService } from '../shared/services/blend.service';
import { UserService } from '../core/user.service';
import { Subscription } from 'rxjs';
import * as fromRoot from '../reducers';
import { Store, select } from '@ngrx/store';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-opt-out',
  templateUrl: './opt-out.component.html',
  styleUrls: ['./opt-out.component.scss'],
})
export class OptOutComponent implements OnInit {
  private subscription: Subscription;
  public isLoading = true;
  constructor(
    private apiService: ApiService,
    private blendService: BlendService,
    private userService: UserService,
    private store: Store<fromRoot.State>,
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.optOut();
    this.subscription = this.store.pipe(select(fromRoot.getAuthUser)).subscribe(async (data) => {
      if (data.is_newui_disabled) {
        // added 0.5 second wait before redirecting to cp to update user session on cp
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
        setTimeout(() => {
          this.isLoading = false;
          window.location.href = environment.cphost + '/opt-out';
        }, 500);
      }
    });
  }

  private async optOut(): Promise<void> {
    const result = await this.apiService.execute<UserInfoSetApiOutput>('userinfoset', {
      newui: 1,
    });
    if (result.success) {
      this.blendService.track(BlendEvent.NEW_UI_OPT_OUT, {});
      this.userService.refresh();
    }
  }
}
